import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { LettersApi, type GetLettersContentResponse } from '@shared/api';

interface UseLetterContentStore {
  data?: GetLettersContentResponse | null;
  loading: boolean;
  error: string | null;
  getLetterContent: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useLetterContentStore = create<UseLetterContentStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  getLetterContent: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, data: undefined, error: null });
      const result = await LettersApi.getLetterContent(id, signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, data: null, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
